import { render, staticRenderFns } from "./tradeList.vue?vue&type=template&id=38be1d25&"
import script from "./tradeList.vue?vue&type=script&lang=js&"
export * from "./tradeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38be1d25')) {
      api.createRecord('38be1d25', component.options)
    } else {
      api.reload('38be1d25', component.options)
    }
    module.hot.accept("./tradeList.vue?vue&type=template&id=38be1d25&", function () {
      api.rerender('38be1d25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/components/tradeList.vue"
export default component.exports